import React from 'react'
import { useNavigate } from 'react-router-dom';
import { CardActionArea, Paper, Typography } from "@mui/material";
import { makeStyles } from '@material-ui/core';

import { formatNumberToEuroString } from '../../utils/FormatToPrice';

const useStyle = makeStyles(theme => {

    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: 'black',
            borderRadius: 4,
            transition: '0.4s',
            '&:hover': {
                transform: 'scale(1.1)'
            },

        },
        title: {
            fontWeight: 'bold',
            marginBottom: 5
        }
    }
})

const ProjectCard = ({ project }) => {
    const classes = useStyle()
    const navigate = useNavigate()

    const cardWidthAndHeigth = { xs: 150, md: 200 };


    const handleNavigateToProject = () => {
        navigate(`/project/${project.projectId}`)
    }

    return (
        <Paper sx={{ width: cardWidthAndHeigth, height: cardWidthAndHeigth }} elevation={5}>
            <CardActionArea onClick={() => handleNavigateToProject()} sx={{ width: cardWidthAndHeigth, height: cardWidthAndHeigth }} className={classes.container}>
                <Typography color='secondary' sx={{ fontSize: 20, textAlign: 'center' }} className={classes.title}>{project.title}</Typography>
                <Typography color='secondary'>{formatNumberToEuroString(project.solde)} €</Typography>
            </CardActionArea>
        </Paper>
    )
}

export default ProjectCard;